import React from 'react'
import styled from 'styled-components'
import aggregator from '../../../../lib/aggregator'
import media from '../../../utils/style'

import PrimaryActions from '../../../components/PrimaryActions'

const normaliseData = (property, usedVehicles) => {
  const counts = aggregator(property, usedVehicles)
  return Number(counts.car + counts.lifestyle).toLocaleString()
}

const ContentFrame = styled.div`
  width: 100%;
  max-width: 1360px;
  margin-left: auto;
  margin-right: auto;
  ${media.MediumScreenUp`
    margin-bottom: 20px;
  `}

  ${media.LargeScreenUp`
    margin-bottom: 40px;
  `}
`

const PrimaryActionsWidget = (props) => {
  const count = normaliseData('category', props.usedVehicles)
  return (
    <ContentFrame>
      <PrimaryActions count={count} />
    </ContentFrame>
  )
}

export default PrimaryActionsWidget
